export const SMSCategories = {
    ALERT: 'Alert',
    BARRIER_CONTROL: 'BarrierControl',
    ALERT_NEW_CUSTOMERS: 'alert_new_customers',
};

export const SMSCategoriesTranslationKeys = {
    [SMSCategories.ALERT]: 'reports.smsCategories.alert',
    [SMSCategories.BARRIER_CONTROL]: 'reports.smsCategories.barrier-control',
    [SMSCategories.ALERT_NEW_CUSTOMERS]: 'reports.smsCategories.alert-new-customers',
};
